import { render, staticRenderFns } from "./ChangeUserPasswordForm.vue?vue&type=template&id=8a34d24c"
import script from "./ChangeUserPasswordForm.vue?vue&type=script&lang=js"
export * from "./ChangeUserPasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports